/* assets/upk-look.js (P13e-delta.2, 23 Oct 2026): the design team's header scripts, moved out of the HTML verbatim and deferred
   (loaded from sections/header.liquid). Part 1 is the desktop mega menu (snippets/up-mega-nav.liquid: hover and click-to-pin
   panels, the category rail, the banner cards from the header blocks' JSON) plus the on-demand panels: the first hover, the
   first touch of the phone menu button or the idle moment after load fetches the header section rendered on
   /collections/all?view=upk-api and copies each panel in by its index (the P13c.1d technique). Part 2 is the phone menu
   (snippets/header-drawer.liquid: open, close, the two-pane rail, the self-healing rail, the accordions), its pane bodies
   filled from the same fetch. Part 3 is the Offers-pane swap and the card hover-photo loader from sections/upk-header-look.liquid.
   Part 4 is the card + button watcher from snippets/card-product.liquid (once per page, not once per card section).
   The header re-parenting script stays inline in sections/upk-header-look.liquid (it must run before first paint). */

/* ===== Part 1: desktop mega menu (snippets/up-mega-nav.liquid) ===== */
  (function () {
    var mq = window.matchMedia('(min-width:990px)');
    var pinned = null;
    var CAT_STYLE = 'display:flex !important;visibility:visible !important;opacity:1 !important;position:static !important;clip-path:none !important;width:auto !important;height:auto !important;overflow:visible !important;text-indent:0 !important;transform:none !important;';
    var SPAN_STYLE = 'display:inline !important;visibility:visible !important;opacity:1 !important;position:static !important;width:auto !important;height:auto !important;overflow:visible !important;clip-path:none !important;';

    function bannerKey(tab, cat) { return (tab || '').toLowerCase().trim() + '||' + (cat || '').toLowerCase().trim(); }

    function isRich(b) { return !!(b && (b.title || b.badge_text || b.button_text || b.subtext)); }

    function buildPromoCardHtml(b) {
      var style = b.card_bg ? ' style="background:' + b.card_bg + '"' : '';
      var html = '<div class="up-promocard"' + style + '>';
      if (b.image) {
        var alt = (b.alt || '').replace(/"/g, '&quot;');
        html += '<div class="up-promocard__img"><img src="' + b.image + '" alt="' + alt + '" loading="lazy" width="300" height="300"></div>';
      }
      if (b.badge_text) {
        var bstyle = [];
        if (b.badge_bg) bstyle.push('background:' + b.badge_bg, 'border-color:transparent');
        if (b.badge_fg) bstyle.push('color:' + b.badge_fg);
        html += '<div class="up-promocard__badge"' + (bstyle.length ? ' style="' + bstyle.join(';') + '"' : '') + '>' + b.badge_text + '</div>';
      }
      if (b.title) {
        html += '<div class="up-promocard__title"' + (b.title_color ? ' style="color:' + b.title_color + '"' : '') + '>' + b.title + '</div>';
      }
      if (b.subtitle) {
        html += '<div class="up-promocard__subtitle"' + (b.subtitle_color ? ' style="color:' + b.subtitle_color + '"' : '') + '>' + b.subtitle + '</div>';
      }
      if (b.subtext) {
        var lines = b.subtext.split(/\r?\n/).map(function (l) { return l.trim(); }).filter(function (l) { return l !== ''; });
        if (b.subtext_bg || b.subtext_color) {
          var chipStyle = [];
          if (b.subtext_bg) chipStyle.push('background:' + b.subtext_bg);
          if (b.subtext_color) chipStyle.push('color:' + b.subtext_color);
          var chipStyleAttr = chipStyle.length ? ' style="' + chipStyle.join(';') + '"' : '';
          var chipsHtml = lines.map(function (line) {
            return '<div class="up-promocard__offer"' + chipStyleAttr + '>' + line + '</div>';
          }).join('');
          html += '<div class="up-promocard__offers">' + chipsHtml + '</div>';
        } else {
          html += '<div class="up-promocard__text">' + lines.join('<br>') + '</div>';
        }
      }
      if (b.button_text) {
        var btnstyle = [];
        if (b.button_bg) btnstyle.push('background:' + b.button_bg);
        if (b.button_fg) btnstyle.push('color:' + b.button_fg);
        html += '<span class="up-promocard__btn"' + (btnstyle.length ? ' style="' + btnstyle.join(';') + '"' : '') + '>' + b.button_text + ' &#8594;</span>';
      }
      html += '</div>';
      return html;
    }

    function setBannerContent(a, b) {
      var defaultHref = a.getAttribute('data-default-href') || a.getAttribute('href');
      if (isRich(b)) {
        a.classList.remove('has-img');
        a.classList.add('has-rich');
        a.setAttribute('href', b.link || defaultHref);
        a.innerHTML = buildPromoCardHtml(b);
      } else if (b && b.image) {
        a.classList.remove('has-rich');
        a.classList.add('has-img');
        a.setAttribute('href', b.link || defaultHref);
        var alt = (b.alt || '').replace(/"/g, '&quot;');
        a.innerHTML = '<img src="' + b.image + '" alt="' + alt + '" loading="lazy" width="300" height="300">';
      } else {
        a.classList.remove('has-img', 'has-rich');
        a.setAttribute('href', defaultHref);
        a.innerHTML = '<span class="up-banner__deco">&#9670;</span>';
      }
    }

    var tabBannerMap = {};
    var categoryBannerMap = {};
    /* P13e-delta.2b: the banner JSON blobs are in the page only in the theme editor; on a page they come with the fetched header
       (fillPanels reads them from that document before the banners are applied). Legacy up-mega-config first, header blocks override. */
    function readBannerMaps(scope) {
      ['UpMegaBanners','UpMegaBannersHeader'].forEach(function (id) { try { var el = scope.getElementById(id); if (el) { JSON.parse(el.textContent).forEach(function (b) { if (b.tab) tabBannerMap[String(b.tab).toLowerCase().trim()] = b; }); } } catch (e) {} });
      try { var cel = scope.getElementById('UpMegaCategoryBanners'); if (cel) { JSON.parse(cel.textContent).forEach(function (b) { categoryBannerMap[bannerKey(b.tab, b.category)] = b; }); } } catch (e) {}
    }
    readBannerMaps(document);

    function applyCategoryBanner(panel, cat) {
      if (!cat) return;
      var bannerEl = panel.querySelector('[data-up-banner]');
      var tabName = '';
      var catName = (cat.getAttribute('data-cat') || '').toLowerCase().trim();
      var catBanner = null;
      if (bannerEl) {
        tabName = (bannerEl.getAttribute('data-tab') || '').toLowerCase().trim();
        catBanner = categoryBannerMap[bannerKey(tabName, catName)];
        setBannerContent(bannerEl, catBanner || tabBannerMap[tabName]);
      }
      var noteEl = panel.querySelector('[data-categories-note]');
      if (noteEl) {
        if (catBanner && catBanner.note) {
          noteEl.textContent = catBanner.note;
          noteEl.style.display = 'block';
        } else {
          noteEl.textContent = '';
          noteEl.style.display = 'none';
        }
      }
    }

    function bindCats(panel) {
      var cats = panel.querySelectorAll('.up-rail__cat');
      var panels = panel.querySelectorAll('.up-dyn__panel');
      cats.forEach(function (cat) {
        if (cat.dataset.upBound) return;
        cat.dataset.upBound = '1';
        function act() {
          var k = cat.getAttribute('data-idx');
          cats.forEach(function (c) { c.classList.toggle('is-active', c === cat); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-idx') === k); });
          applyCategoryBanner(panel, cat);
        }
        cat.addEventListener('mouseenter', act); cat.addEventListener('focus', act);
      });
      /* Show the correct banner for whichever category is active by default (usually the first) */
      var activeCat = panel.querySelector('.up-rail__cat.is-active') || cats[0];
      applyCategoryBanner(panel, activeCat);
      return cats;
    }

    /* Self-healing rail: rebuild category links from embedded JSON if they are missing */
    function ensureRail(panel) {
      var rail = panel.querySelector('.up-nav-rail');
      if (!rail) return;
      if (rail.querySelector('.up-rail__cat')) { bindCats(panel); return; }
      var dataEl = rail.querySelector('.up-rail-data');
      if (!dataEl) return;
      var items = [];
      try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!items.length) return;
      items.forEach(function (it, idx) {
        var a = document.createElement('a');
        a.href = it.u;
        a.className = 'up-rail__cat' + (idx === 0 ? ' is-active' : '');
        a.setAttribute('data-idx', String(it.i));
        a.setAttribute('data-cat', String(it.t || '').toLowerCase().trim());
        a.setAttribute('style', CAT_STYLE);
        var s = document.createElement('span');
        s.setAttribute('style', SPAN_STYLE);
        s.textContent = it.t;
        a.appendChild(s);
        rail.appendChild(a);
      });
      bindCats(panel);
    }

    /* P13e-delta.2 (P13c.1d): the panels are not in the page. The first hover on the nav, the first touch of the phone menu button,
       or the idle moment two seconds after load fetches this header section rendered on /collections/all?view=upk-api, where both
       menus print their full panels (data-up-panel-key, data-up-macc-key), and each panel is copied in by its index. One request,
       cached for the page; the same promise serves the phone menu (part 2). */
    var panelsPromise = null;
    function headerSectionId() {
      var s = document.querySelector('.up-nav') || document.querySelector('[data-up-mnav]');
      var sec = s && s.closest('.shopify-section');
      return sec ? sec.id.replace(/^shopify-section-/, '') : '';
    }
    function ensurePanels() {
      if (panelsPromise) return panelsPromise;
      var id = headerSectionId(); if (!id) return Promise.reject(new Error('no header'));
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      panelsPromise = fetch(root + 'collections/all?view=upk-api&sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (json) { var html = json[id]; if (!html) throw new Error('no header'); return new DOMParser().parseFromString(html, 'text/html'); })
        .catch(function (e) { panelsPromise = null; throw e; });
      return panelsPromise;
    }
    window.__upkMegaPanels = ensurePanels;
    /* P13e-delta.2c: the chip-link rewrite of snippets/up-mega-chip-links (filter.p.tag links to /collections/<handle>/<tag>) ran as
       an inline script inside the Offers panel; a fetched panel's scripts never run, so the rewrite runs here on every filled panel. */
    function tagHandle(s) { return String(s).toLowerCase().trim().replace(/['"\u2019]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function fixChipLinks(scope) {
      (scope || document).querySelectorAll('a.up-chip[href*="filter.p.tag="]').forEach(function (a) {
        try {
          var u = new URL(a.getAttribute('href'), location.origin);
          var tg = u.searchParams.get('filter.p.tag');
          if (!tg) return;
          var p = u.pathname.replace(/\/+$/, '');
          if (!/\/collections\/[^\/]+$/.test(p)) return;
          a.setAttribute('href', p + '/' + tagHandle(tg));
        } catch (e) {}
      });
    }
    function fillPanels(doc) {
      if (!document.getElementById('UpMegaBannersHeader')) readBannerMaps(doc);
      document.querySelectorAll('[data-up-panel-lazy]').forEach(function (p) {
        var key = p.getAttribute('data-up-panel-lazy');
        var from = doc.querySelector('[data-up-panel-key="' + key + '"]');
        var inner = p.querySelector('.up-megapanel__inner');
        if (!from || !inner) return;
        inner.innerHTML = '';
        Array.prototype.slice.call(from.childNodes).forEach(function (n) { inner.appendChild(document.importNode(n, true)); });
        p.removeAttribute('data-up-panel-lazy');
        fixChipLinks(inner);
        ensureRail(p);
        p.querySelectorAll('[data-up-banner]').forEach(function (a) { setBannerContent(a, tabBannerMap[(a.getAttribute('data-tab') || '').toLowerCase().trim()]); });
        bindCats(p);
      });
    }
    function panelsReady() {
      if (!document.querySelector('[data-up-panel-lazy]')) return Promise.resolve();
      return ensurePanels().then(fillPanels);
    }
    window.__upkPanelsReady = panelsReady;
    fixChipLinks(document);
    function closeAll() { document.querySelectorAll('.up-megapanel.is-open').forEach(function (p) { p.classList.remove('is-open'); }); document.querySelectorAll('.up-li--has.is-pinned').forEach(function (l) { l.classList.remove('is-pinned'); }); pinned = null; }
    document.querySelectorAll('.up-nav .up-li--has').forEach(function (li) {
      var link = li.querySelector('.up-nav__link');
      var panel = li.querySelector('[data-up-panel]');
      if (!panel) return;
      var t;
      ensureRail(panel);
      function show() {
        if (panel.hasAttribute('data-up-panel-lazy')) { panelsReady().then(function () { if (pinned === panel || li.matches(':hover')) show(); }).catch(function () {}); return; }
        document.querySelectorAll('.up-megapanel.is-open').forEach(function (p) { if (p !== panel) p.classList.remove('is-open'); }); ensureRail(panel); panel.classList.add('is-open');
      }
      li.addEventListener('mouseenter', function () { if (!mq.matches) return; clearTimeout(t); if (pinned) return; show(); });
      li.addEventListener('mouseleave', function () { if (pinned === panel) return; clearTimeout(t); t = setTimeout(function () { panel.classList.remove('is-open'); }, 160); });
      panel.addEventListener('mouseenter', function () { clearTimeout(t); });
      panel.addEventListener('mouseleave', function () { if (pinned === panel) return; clearTimeout(t); t = setTimeout(function () { panel.classList.remove('is-open'); }, 160); });
      if (link) { link.addEventListener('click', function (e) { if (!mq.matches) return; e.preventDefault(); if (pinned === panel) { closeAll(); } else { closeAll(); show(); pinned = panel; li.classList.add('is-pinned'); } }); }
      bindCats(panel);
    });
    /* prefetch: the pointer reaching the nav, and the idle moment two seconds after load (every panel in one request) */
    var navEl = document.querySelector('.up-nav');
    if (navEl) { ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { navEl.addEventListener(ev, function () { panelsReady().catch(function () {}); }, { once: true, passive: true }); }); }
    function idlePrefetch() {
      if (!document.querySelector('[data-up-panel-lazy], [data-up-macc-lazy]')) return;
      var c = navigator.connection; if (c && c.saveData) return;
      var go = function () { panelsReady().catch(function () {}); };
      setTimeout(function () { if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 4000 }); else go(); }, 2000);
    }
    if (document.readyState === 'complete') idlePrefetch(); else window.addEventListener('load', idlePrefetch);
    document.addEventListener('click', function (e) { if (!pinned) return; if (e.target.closest && (e.target.closest('.up-megapanel') || e.target.closest('.up-nav__link'))) return; closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    /* Re-check shortly after load in case another script strips the rail links */
    if (document.readyState !== 'loading') { setTimeout(function(){ document.querySelectorAll('[data-up-panel]').forEach(ensureRail); }, 800); }
    else { document.addEventListener('DOMContentLoaded', function(){ setTimeout(function(){ document.querySelectorAll('[data-up-panel]').forEach(ensureRail); }, 800); }); }
    function applyBanners() {
      document.querySelectorAll('[data-up-banner]').forEach(function (a) {
        var tab = (a.getAttribute('data-tab') || '').toLowerCase().trim();
        setBannerContent(a, tabBannerMap[tab]);
      });
    }
    if (document.readyState !== 'loading') applyBanners(); else document.addEventListener('DOMContentLoaded', applyBanners);
  })();

/* ===== Part 2: phone menu (snippets/header-drawer.liquid) ===== */
  (function () {
    var root = document.querySelector('[data-up-mnav]');
    if (!root || root.dataset.upReady) return;
    root.dataset.upReady = '1';
    var panel = root.querySelector('.up-mnav__panel');
    var scrim = root.querySelector('.up-mnav__scrim');
    var opensTrig = root.querySelectorAll('[data-up-open]');
    var closesTrig = root.querySelectorAll('[data-up-close]');
    var prevOverflow = '';

    // Move overlay nodes to <body> so position:fixed covers the full viewport
    // (including the announcement bar), escaping the sticky header's stacking context.
    if (scrim) document.body.appendChild(scrim);
    if (panel) document.body.appendChild(panel);

    /* P13e-delta.2 (P13c.1d): the pane bodies and the bottom block arrive with the first touch of the menu button (prefetch) or
       the first open, from the same header render the desktop panels use (window.__upkMegaPanels, part 1); the drawer opens at
       once with the rail text and the pictures follow. In the theme editor the bodies are printed and nothing is fetched. */
    var built = false, filling = null;
    function fillDrawer(doc) {
      (panel || root).querySelectorAll('[data-up-macc-lazy]').forEach(function (body) {
        var key = body.getAttribute('data-up-macc-lazy');
        var from = doc.querySelector('[data-up-macc-key="' + key + '"]');
        if (!from) return;
        body.innerHTML = '';
        Array.prototype.slice.call(from.childNodes).forEach(function (n) { body.appendChild(document.importNode(n, true)); });
        body.removeAttribute('data-up-macc-lazy');
      });
    }
    function build() {
      if (built) return;
      if (!(panel || root).querySelector('[data-up-macc-lazy]')) { built = true; bindExtras(); try { document.dispatchEvent(new CustomEvent('upk:mnav-built')); } catch (e) {} return; }
      if (filling) return;
      if (!window.__upkMegaPanels) return;
      filling = window.__upkMegaPanels().then(function (doc) {
        fillDrawer(doc);
        built = true; filling = null;
        bindExtras();
        try { document.dispatchEvent(new CustomEvent('upk:mnav-built')); } catch (e) {}
      }).catch(function () { filling = null; });
    }
    function open() {
      build();
      if (panel) panel.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      opensTrig.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      if (panel) { try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }
    }
    function close() {
      if (panel) panel.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      opensTrig.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.body.style.overflow = prevOverflow || '';
    }
    opensTrig.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    closesTrig.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); close(); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) close(); });

    opensTrig.forEach(function (b) {
      b.addEventListener('touchstart', build, { passive: true });
      b.addEventListener('mouseenter', build);
      b.addEventListener('pointerdown', build);
    });
    /* 21 Oct: no timed background build any more (it ran on desktop too, where this menu is never shown, and showed up
       as blocking time in PageSpeed). The menu builds on the first touch or click of the menu button only. */

    function bindExtras() {
    (panel || root).querySelectorAll('[data-offer-more]').forEach(function (btn) {
      if (btn.dataset.upkBound) return;
      btn.dataset.upkBound = '1';
      if (!btn.dataset.moreLabel) btn.dataset.moreLabel = btn.textContent;
      btn.addEventListener('click', function () {
        var extra = btn.nextElementSibling;
        if (!extra) return;
        if (btn.hasAttribute('data-hide-on-open')) {
          extra.removeAttribute('hidden');
          btn.setAttribute('hidden', '');
          return;
        }
        var isHidden = extra.hasAttribute('hidden');
        if (isHidden) {
          extra.removeAttribute('hidden');
          btn.textContent = 'Show Less';
        } else {
          extra.setAttribute('hidden', '');
          btn.textContent = btn.dataset.moreLabel;
        }
      });
    });

    (panel || root).querySelectorAll('[data-acc]').forEach(function (btn) {
      if (btn.dataset.upkBound) return;
      btn.dataset.upkBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.parentNode;
        var willOpen = !item.classList.contains('is-open');
        if (item.classList.contains('up-macc__item')) {
          Array.prototype.forEach.call(item.parentNode.children, function (o) {
            if (o !== item && o.classList && o.classList.contains('is-open')) {
              o.classList.remove('is-open');
              var h = o.querySelector('.up-macc__head');
              if (h) h.setAttribute('aria-expanded', 'false');
            }
          });
        }
        item.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
    }
    bindExtras();

    // Two-pane category browser (rail on the left, image tiles on the right).
    (function () {
      var twopane = (panel || root).querySelector('[data-up-twopane]');
      if (!twopane) return;

      var RAIL_STYLE = 'display:block !important;visibility:visible !important;opacity:1 !important;position:static !important;width:100% !important;height:auto !important;overflow:visible !important;clip-path:none !important;-webkit-clip-path:none !important;text-indent:0 !important;transform:none !important;max-width:none !important;max-height:none !important;min-height:0 !important;pointer-events:auto !important;';
      var SPAN_STYLE = 'display:inline-flex !important;visibility:visible !important;opacity:1 !important;';

      // Always look these up fresh rather than caching the node: if a page script
      // swaps out the whole .upmnav-catrail or .up-pane element (not just its children),
      // a closed-over reference would point at a detached node forever and every
      // fix below would silently target nothing.
      function getRail() { return twopane.querySelector('[data-upmnav-catrail]'); }
      function getPaneRoot() { return twopane.querySelector('[data-up-pane]'); }

      function activate(idx) {
        var rail = getRail();
        var paneRoot = getPaneRoot();
        if (rail) {
          rail.querySelectorAll('.upmnav-catrail__item').forEach(function (i) {
            i.classList.toggle('is-active', i.getAttribute('data-idx') === idx);
          });
        }
        if (paneRoot) {
          paneRoot.querySelectorAll('.up-pane__panel').forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-idx') === idx);
          });
        }
      }

      function bindRailClicks() {
        var rail = getRail();
        if (!rail) return;
        rail.querySelectorAll('[data-acc2]').forEach(function (btn) {
          if (btn.dataset.upBound) return;
          btn.dataset.upBound = '1';
          btn.addEventListener('click', function () { activate(btn.getAttribute('data-idx')); });
        });
      }

      // Snapshot the rail's item list once, from whichever copy of the JSON data
      // script exists at first read. Kept in memory so healing still works even if
      // a page script later removes that script tag along with the rail markup.
      var railItems = null;
      function captureItems() {
        if (railItems) return;
        var rail = getRail();
        if (!rail) return;
        var dataEl = rail.querySelector('.up-mrail-data');
        if (!dataEl) return;
        try {
          var parsed = JSON.parse(dataEl.textContent);
          if (parsed && parsed.length) railItems = parsed;
        } catch (e) {}
      }

      // Self-healing: some page script can strip, hide, restyle individual rail
      // items, OR replace the whole .upmnav-catrail / .up-pane element outright. Every
      // run: (1) re-fetches live nodes rather than trusting stale references,
      // (2) re-forces visibility styles on whatever items currently exist,
      // (3) rebuilds any missing items from the captured JSON snapshot.
      function ensureRail() {
        var rail = getRail();
        if (!rail) return;
        captureItems();

        rail.querySelectorAll('.upmnav-catrail__item').forEach(function (n) {
          if (n.getAttribute('style') !== RAIL_STYLE) n.setAttribute('style', RAIL_STYLE);
          var s = n.querySelector('span');
          if (s && s.getAttribute('style') !== SPAN_STYLE) s.setAttribute('style', SPAN_STYLE);
        });

        if (!railItems || !railItems.length) return;
        var current = rail.querySelectorAll('.upmnav-catrail__item').length;
        if (current >= railItems.length) return;

        rail.querySelectorAll('.upmnav-catrail__item').forEach(function (n) { n.remove(); });
        railItems.forEach(function (it) {
          var el;
          if (it.has) {
            el = document.createElement('button');
            el.type = 'button';
            el.setAttribute('data-acc2', '');
          } else {
            el = document.createElement('a');
            el.href = it.u;
          }
          el.className = 'upmnav-catrail__item';
          el.setAttribute('data-idx', String(it.i));
          el.setAttribute('style', RAIL_STYLE);
          var span = document.createElement('span');
          span.setAttribute('style', SPAN_STYLE);
          span.textContent = it.t;
          if (it.badge) {
            var b = document.createElement('span');
            b.className = 'up-macc__badge';
            b.textContent = it.badge;
            span.appendChild(b);
          }
          el.appendChild(span);
          rail.appendChild(el);
        });
        bindRailClicks();
      }

      captureItems();
      bindRailClicks();
      ensureRail();

      // Activate whichever rail button is already marked is-active (current category),
      // otherwise fall back to the first rail button with a panel.
      (function () {
        var rail = getRail();
        if (!rail) return;
        var already = rail.querySelector('.upmnav-catrail__item.is-active[data-idx]');
        var first = already || rail.querySelector('[data-acc2]');
        if (first) activate(first.getAttribute('data-idx'));
      })();

      // Keep watching the whole two-pane container (not just the rail node) so a
      // full replacement of .upmnav-catrail or .up-pane is caught too, not only edits to
      // items already inside them.
      if (window.MutationObserver) {
        try {
          new MutationObserver(function () { ensureRail(); }).observe(twopane, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class', 'hidden']
          });
        } catch (e) {}
      }
      // Fallback rechecks in case the stripping happens via non-mutation means, and
      // keeps happening repeatedly rather than just once. A repeating interval
      // outlasts a script that re-strips on its own timer or reruns after a delay.
      // 21 Oct (speed): the repeating recheck now starts when the menu is first built (opened), not on every page load.
      function startHeal() {
        var healTicks = 0;
        var healInterval = setInterval(function () {
          ensureRail();
          healTicks += 1;
          if (healTicks >= 40) clearInterval(healInterval); // ~20s of active healing
        }, 500);
      }
      document.addEventListener('upk:mnav-built', startHeal, { once: true });
    })();
  })();

/* ===== Part 3: Offers pane cards and the card hover photo (sections/upk-header-look.liquid) ===== */
  (function () {
    function upkOffers() {
      var tpl = document.getElementById('upk-moff-tpl');
      if (!tpl) return;
      var items = document.querySelectorAll('.up-mnav__panel .upmnav-catrail__item[data-idx]');
      var idx = null;
      Array.prototype.forEach.call(items, function (it) { if (/^\s*offers?\b/i.test(it.textContent)) idx = it.getAttribute('data-idx'); });
      if (!idx) return;
      var pane = document.querySelector('.up-mnav__panel .up-pane__panel[data-idx="' + idx + '"]');
      if (!pane || pane.getAttribute('data-upk-moff')) return;
      if (pane.querySelector('template[data-upk-lazy]') || pane.hasAttribute('data-up-macc-lazy')) return; /* menu not built or not filled yet: runs again on upk:mnav-built */
      pane.setAttribute('data-upk-moff', '1');
      var viewAll = pane.querySelector('.up-viewall-m');
      pane.innerHTML = '';
      pane.appendChild(tpl.content.cloneNode(true));
      if (viewAll) pane.appendChild(viewAll);
      var btn = pane.querySelector('[data-upk-moff-more]');
      var extra = pane.querySelector('.upk-moff__extra');
      if (btn && extra) btn.addEventListener('click', function () {
        var hide = !extra.hasAttribute('hidden');
        if (hide) { extra.setAttribute('hidden', ''); btn.textContent = 'More offers'; } else { extra.removeAttribute('hidden'); btn.textContent = 'Show less'; }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', upkOffers); else upkOffers();
    window.addEventListener('load', upkOffers);
    document.addEventListener('upk:mnav-built', upkOffers);
  })();

  /* 21 Oct (speed): product-card hover photos load on the first hover over a card (see snippets/card-product.liquid). */
  (function () {
    if (window.__upkPcHover) return; window.__upkPcHover = 1;
    function wake(card) {
      var i = card && card.querySelector('img.pc-i2[data-src]');
      if (!i) return;
      if (i.getAttribute('src')) { i.removeAttribute('data-src'); i.removeAttribute('data-srcset'); return; }
      if (i.getAttribute('data-srcset')) i.setAttribute('srcset', i.getAttribute('data-srcset'));
      i.setAttribute('src', i.getAttribute('data-src'));
      i.removeAttribute('data-src'); i.removeAttribute('data-srcset');
    }
    document.addEventListener('mouseover', function (e) { var c = e.target.closest && e.target.closest('.pc'); if (c) wake(c); }, { passive: true });
    document.addEventListener('focusin', function (e) { var c = e.target.closest && e.target.closest('.pc'); if (c) wake(c); });
  })();

/* ===== Part 4: the card + button watcher (snippets/card-product.liquid) ===== */
  /* The card add script writes "Adding" and "Added to Bag" into the button; the square + shows a tick instead. */
  if (!window.upkPlusWatch) {
    window.upkPlusWatch = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button.pc-plus');
      if (!b) return;
      var sync = function () {
        var t = b.textContent || '';
        b.classList.toggle('is-added', /added/i.test(t));
        b.classList.toggle('is-busy', /adding/i.test(t));
      };
      var o = new MutationObserver(sync);
      o.observe(b, { childList: true, characterData: true, subtree: true });
      setTimeout(function () { o.disconnect(); b.classList.remove('is-added', 'is-busy'); }, 6000);
    }, true);
  }

